var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .filtering-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:15.1181;}\r\n        .filtering-st1{fill:none;stroke:currentColor;stroke-width:10;stroke-miterlimit:15.1181;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect77",
    x: 67.7,
    y: 69.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -75.496 180.3086)",
    className: "filtering-st0",
    width: 224.5,
    height: 224.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2658",
    className: "filtering-st1",
    d: "M179.9,22.6v311"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltering);
export default __webpack_public_path__ + "static/media/filtering.002bd97bcefd0415c80129e3f45efb05.svg";
export { ForwardRef as ReactComponent };